/* eslint-disable */
import React, {
  useEffect,
  useState,
  useMemo,
  useContext,
  useCallback,
} from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { MaterialReactTable } from "material-react-table";
import { MenuItem, Box } from "@mui/material";

import { GlobalProvider } from "context/GlobalContext";

import { assetImages } from "constants";

import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import CompanyTypeHeader from "./Header/CompanyTypeHeader";
import SaveCompanyTypePopup from "./Popup/SaveCompanyTypePopup";
// import CompanyTypeFilterPopup from "./Popup/CompanyTypeFilterPopup";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { mergeListById } from "helper/Common/CommonHelper";

const CompanyTypeBody = () => {
  const token = localStorage.getItem("token");
  const savedCompanyTypeId = localStorage.getItem("companytype");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { t, i18n } = useTranslation();
  const { screenHeight } = useContext(GlobalProvider);

  const [companyTypeList, setCompanyTypeList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [companyTypeId, setCompanyTypeId] = useState(null);

  const [filterModuleName, setFilterModuleName] = useState("");
  const [filterModuleSlug, setFilterModuleSlug] = useState("");
  const [filterDateRange, setFilterDateRange] = useState("");

  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedCompanyTypeIds, setSelectedCompanyTypeIds] = useState([]);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const getAllCompanyTypes = async () => {
    setRowSelection({});
    setSelectedCompanyTypeIds([]);

    try {
      setIsLoading(true);
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_ALL_COMPANY_TYPE}?token=${token}`;

      const response = await getData(requestUrl);

      setIsLoading(false);
      if (response.status) {
        setCompanyTypeList(response.data);
      }
    } catch (error) {
      console.error("Error fetching all company types:", error.message);
    }
  };

  // const getFilteredCompanyTypes = useCallback(async () => {
  //   try {
  //     setIsLoading(true);
  //     const requestUrl = `${url.API_BASE_URL}${url.API_GET_FILTERED_COMPANY_TYPE}?token=${token}`;

  //     const sanitizedQuery = jsonFilterQuery.map((filter) => {
  //       if (
  //         (filter.operator === "includes" || filter.operator === "excludes") &&
  //         Array.isArray(filter.value)
  //       ) {
  //         return {
  //           ...filter,
  //           value: filter.value.map((item) => item.value).join(","),
  //         };
  //       }
  //       return filter;
  //     });

  //     const filterData = {
  //       filters: sanitizedQuery,
  //     };

  //     const response = await postData(requestUrl, filterData);

  //     setIsLoading(false);

  //     if (response.status) {
  //       setCompanyTypeList(response.data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching filtered company types:", error.message);
  //   }
  // }, [token, jsonFilterQuery]);

  const deleteBulkHandler = async () => {
    if (selectedCompanyTypeIds.length > 0) {
      try {
        const companyTypeListToBeDelete = companyTypeList.filter((item) =>
          selectedCompanyTypeIds.includes(item._id)
        );

        let apiData = {
          companytypelist: companyTypeListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_COMPANY_TYPE +
          `?token=${token}`;

        const response = await putData(requestURL, apiData);

        console.log(response);

        if (response.status) {
          setMessageType("success");
          setAlertMessage("Company type deleted successfully");

          setTimeout(() => {
            setCompanyTypeList((prevList) =>
              prevList.filter(
                (item) => !selectedCompanyTypeIds.includes(item._id)
              )
            );
          }, 1500);
        } else {
          setMessageType("error");
          setAlertMessage(response.message);
        }
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one company type");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const afterPopupCLose = (data = []) => {
    setTimeout(() => {
      setCompanyTypeList((prev) => mergeListById(prev, data));
    }, 1000);
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        size: 70,
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveCompanyType"
            aria-controls="saveCompanyType"
            onClick={() => {
              setCompanyTypeId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false,
        enableColumnDragging: false,
        enableSorting: false,
      },
      {
        accessorKey: "name",
        header: t("Name"),
        size: 200,
      },
      {
        accessorKey: "slug",
        header: t("Slug"),
        size: 200,
      },
      {
        accessorKey: "featuredstring",
        header: t("Featured"),
        size: 200,
      },
      {
        accessorKey: "createddate",
        header: t("Date"),
        size: 200,
      },
    ],
    [i18n.language, companyTypeList]
  );

  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    getAllCompanyTypes();
  }, []);

  useEffect(() => {
    if (reloadData) {
      getAllCompanyTypes();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    setSelectedCompanyTypeIds(selectedIdsArray);
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (userInfo.role.slug === "ADMIN" || userInfo.role.slug === "SUPER_ADMIN") {
    return (
      <div id="content_wrapper" className="companytype-body-wrapper">
        <section className="crm-wrapper bg-white pb-5 rounded-3 shadow-sm">
          <div className="container-fluid px-lg-5 py-4">
            <CompanyTypeHeader
              reloadList={resetFilterData}
              changeStatusHandler={deleteBulkHandler}
            />

            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={companyTypeList}
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder: initialColumnOrder }}
                  initialState={{
                    rowSelection,
                    columnOrder: initialColumnOrder,
                  }}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50,
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                  enableColumnResizing
                  enableColumnActions
                  enableColumnFilters
                  enablePagination
                  enableSorting
                  enableBottomToolbar
                  enableTopToolbar
                />
              </div>
            )}
          </div>
        </section>

        <SaveCompanyTypePopup
          afterPopupCLose={afterPopupCLose}
          companyTypeId={companyTypeId}
          setCompanyTypeId={setCompanyTypeId}
        />

        {/* <CompanyTypeFilterPopup
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={resetFilterData}
          moduleSlug="companytypelist"
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
        /> */}

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default CompanyTypeBody;
